export default __webpack_public_path__ + "static/media/tortacapa.257ec40e.png";